import { render, staticRenderFns } from "./recorrencia.vue?vue&type=template&id=fc871e24"
import script from "./recorrencia.vue?vue&type=script&lang=js"
export * from "./recorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports